/* GOWin® Store — core unified v1 — source order preserved */
/* BEGIN assets/gowin-premium.js */
(() => {
  'use strict';

  document.documentElement.classList.add('gowin-premium-ui');

  const CARD_BADGE_CLASS = 'gowin-card-discount-badge';
  const PRODUCT_BADGE_CLASS = 'gowin-product-discount-badge';
  const STYLE_ID = 'gowin-discount-badge-styles';
  const ROOT_SELECTOR = '.card-wrapper, .product__info-container';
  const queuedRoots = new Set();
  let frameId = 0;

  function parseMoney(value) {
    let normalized = String(value || '')
      .replace(/\s/g, '')
      .replace(/[^0-9,.-]/g, '');

    if (!normalized) return NaN;

    const commaIndex = normalized.lastIndexOf(',');
    const dotIndex = normalized.lastIndexOf('.');

    if (commaIndex !== -1 && dotIndex !== -1) {
      normalized = commaIndex > dotIndex
        ? normalized.replace(/\./g, '').replace(',', '.')
        : normalized.replace(/,/g, '');
    } else if (commaIndex !== -1) {
      const decimals = normalized.length - commaIndex - 1;
      normalized = decimals === 2
        ? normalized.replace(',', '.')
        : normalized.replace(/,/g, '');
    } else if (dotIndex !== -1) {
      const decimals = normalized.length - dotIndex - 1;
      if (decimals !== 2) normalized = normalized.replace(/\./g, '');
    }

    return Number(normalized);
  }

  function getDiscountPercentage(priceElement) {
    if (!priceElement) return 0;

    const compareElement = priceElement.querySelector(
      '.price__sale s.price-item--regular, s.price-item--regular'
    );
    const currentElement = priceElement.querySelector(
      '.price__sale .price-item--sale, .price-item--sale'
    );

    const comparePrice = parseMoney(compareElement?.textContent);
    const currentPrice = parseMoney(currentElement?.textContent);

    if (
      !Number.isFinite(comparePrice) ||
      !Number.isFinite(currentPrice) ||
      comparePrice <= 0 ||
      currentPrice >= comparePrice
    ) {
      return 0;
    }

    return Math.max(
      1,
      Math.round(((comparePrice - currentPrice) / comparePrice) * 100)
    );
  }

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .gowin-card-discount-badge {
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
        min-width: 4.8rem;
        padding: .65rem .95rem !important;
        color: #fff !important;
        background: #0f776d !important;
        border: 0 !important;
        border-radius: 999px !important;
        font-size: 1.1rem !important;
        font-weight: 850 !important;
        letter-spacing: .02em !important;
        line-height: 1 !important;
        box-shadow: 0 8px 20px rgba(15, 119, 109, .24) !important;
      }

      .gowin-product-discount-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: fit-content;
        margin: .9rem 0 0;
        padding: .75rem 1.1rem;
        color: #fff;
        background: #0f776d;
        border-radius: 999px;
        font-size: 1.25rem;
        font-weight: 820;
        letter-spacing: .01em;
        line-height: 1;
        box-shadow: 0 8px 20px rgba(15, 119, 109, .2);
      }

      @media screen and (max-width: 749px) {
        .gowin-card-discount-badge {
          min-width: 4.4rem;
          padding: .58rem .78rem !important;
          font-size: 1rem !important;
        }

        .gowin-product-discount-badge {
          margin-top: .75rem;
          font-size: 1.15rem;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function prepareCards(scope) {
    const cards = [];

    if (scope instanceof Element && scope.matches('.card-wrapper')) {
      cards.push(scope);
    }

    scope.querySelectorAll?.('.card-wrapper').forEach((card) => cards.push(card));

    cards.forEach((card) => {
      if (card.dataset.gowinCard === 'true') return;
      card.dataset.gowinCard = 'true';

      const heading = card.querySelector('.card__heading');
      const label = heading?.textContent?.trim();
      if (label) card.setAttribute('aria-label', label);
    });
  }

  function findSaleBadge(card) {
    return Array.from(
      card.querySelectorAll('.card__badge .badge:not(.badge--free-shipping)')
    ).find((candidate) => !/agotado|sold out/i.test(candidate.textContent || ''));
  }

  function restoreCardBadge(badge) {
    if (!badge) return;

    if (badge.dataset.gowinOriginalText) {
      badge.textContent = badge.dataset.gowinOriginalText;
      delete badge.dataset.gowinOriginalText;
    }

    badge.classList.remove(CARD_BADGE_CLASS);
    badge.removeAttribute('aria-label');
  }

  function updateCardDiscountBadges(scope) {
    const cards = [];

    if (scope instanceof Element && scope.matches('.card-wrapper')) {
      cards.push(scope);
    }

    scope.querySelectorAll?.('.card-wrapper').forEach((card) => cards.push(card));

    cards.forEach((card) => {
      const priceElement = card.querySelector('.price--on-sale');
      const badge = findSaleBadge(card);

      if (!priceElement || priceElement.classList.contains('price--sold-out')) {
        restoreCardBadge(badge);
        return;
      }

      const percentage = getDiscountPercentage(priceElement);

      if (!percentage || !badge) {
        restoreCardBadge(badge);
        return;
      }

      if (!badge.dataset.gowinOriginalText) {
        badge.dataset.gowinOriginalText = badge.textContent.trim();
      }

      badge.classList.add(CARD_BADGE_CLASS);
      badge.setAttribute('aria-label', `${percentage}% de descuento`);

      const nextText = `-${percentage}%`;
      if (badge.textContent.trim() !== nextText) badge.textContent = nextText;
    });
  }

  function restoreOriginalSaleBadge(priceElement) {
    const originalBadge = priceElement.querySelector(
      '.price__badge-sale[data-gowin-hidden-sale="true"]'
    );

    if (!originalBadge) return;

    originalBadge.style.removeProperty('display');
    originalBadge.removeAttribute('data-gowin-hidden-sale');
  }

  function updateProductDiscountBadges(scope) {
    const prices = [];

    if (
      scope instanceof Element &&
      scope.matches('.product__info-container .price')
    ) {
      prices.push(scope);
    }

    scope
      .querySelectorAll?.('.product__info-container .price')
      .forEach((price) => prices.push(price));

    prices.forEach((priceElement) => {
      const percentage = priceElement.classList.contains('price--on-sale')
        ? getDiscountPercentage(priceElement)
        : 0;
      let customBadge = priceElement.querySelector(`.${PRODUCT_BADGE_CLASS}`);

      if (!percentage) {
        customBadge?.remove();
        restoreOriginalSaleBadge(priceElement);
        return;
      }

      const originalBadge = priceElement.querySelector(
        `.price__badge-sale:not(.${PRODUCT_BADGE_CLASS})`
      );

      if (originalBadge) {
        originalBadge.style.display = 'none';
        originalBadge.setAttribute('data-gowin-hidden-sale', 'true');
      }

      if (!customBadge) {
        customBadge = document.createElement('span');
        customBadge.className = PRODUCT_BADGE_CLASS;
        customBadge.setAttribute('role', 'status');
        priceElement.appendChild(customBadge);
      }

      const nextText = `${percentage}% de descuento`;
      if (customBadge.textContent !== nextText) customBadge.textContent = nextText;
    });
  }

  function updateScope(scope) {
    const safeScope = scope?.querySelectorAll ? scope : document;
    prepareCards(safeScope);
    updateCardDiscountBadges(safeScope);
    updateProductDiscountBadges(safeScope);
  }

  function flushUpdates() {
    frameId = 0;
    const roots = Array.from(queuedRoots);
    queuedRoots.clear();

    if (roots.includes(document)) {
      updateScope(document);
      return;
    }

    roots.forEach(updateScope);
  }

  function scheduleUpdate(scope = document) {
    queuedRoots.add(scope);
    if (!frameId) frameId = window.requestAnimationFrame(flushUpdates);
  }

  function relevantRoot(node) {
    const element = node instanceof Element ? node : node?.parentElement;
    if (!element) return null;

    return element.closest(ROOT_SELECTOR) ||
      (element.matches(ROOT_SELECTOR) || element.querySelector?.(ROOT_SELECTOR)
        ? element
        : null);
  }

  function startObserver() {
    if (!document.body || !document.querySelector(ROOT_SELECTOR)) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const targetRoot = relevantRoot(mutation.target);
        if (targetRoot) scheduleUpdate(targetRoot);

        mutation.addedNodes.forEach((node) => {
          const root = relevantRoot(node);
          if (root) scheduleUpdate(root);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    ensureStyles();
    updateScope(document);
    startObserver();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init, { once: true })
    : init();

  document.addEventListener('shopify:section:load', (event) => {
    scheduleUpdate(event.target);
  });

  document.addEventListener('shopify:section:reorder', () => {
    scheduleUpdate(document);
  });

  document.addEventListener('variant:change', (event) => {
    scheduleUpdate(
      event.target?.closest?.('.product__info-container') || document
    );
  });
})();

/* END assets/gowin-premium.js */

/* BEGIN assets/gowin-audit-improvements.js */
/* GOWin audit bootstrap — preserves existing behavior and fixes full drawer scroll. */
(()=>{
  const hostScript=document.currentScript||[...document.scripts].find(script=>script.src.includes('gowin-audit-improvements.js'));
  const hostSrc=hostScript?.src||'';
  const coreSrc=hostSrc.replace(/gowin-audit-improvements\.js(?=\?|$)/,'gowin-audit-improvements-core.js');
  const STYLE_ID='gowin-drawer-unified-scroll';

  const applyScrollFix=()=>{
    let style=document.getElementById(STYLE_ID);

    if(!style){
      style=document.createElement('style');
      style.id=STYLE_ID;
      style.textContent=`
        html body cart-drawer.drawer .cart-drawer .drawer__inner{
          display:flex!important;
          flex-direction:column!important;
          height:100vh!important;
          height:100dvh!important;
          min-height:0!important;
          overflow-x:hidden!important;
          overflow-y:auto!important;
          overscroll-behavior-x:none!important;
          overscroll-behavior-y:contain!important;
          -webkit-overflow-scrolling:touch!important;
          scroll-padding-bottom:max(2.4rem,env(safe-area-inset-bottom))!important;
          touch-action:pan-y!important;
        }

        html body cart-drawer.drawer .cart-drawer .drawer__header{
          position:sticky!important;
          top:0!important;
          z-index:20!important;
          flex:0 0 auto!important;
          width:100%!important;
          background:rgb(var(--color-background))!important;
        }

        html body cart-drawer.drawer .cart-drawer cart-drawer-items{
          display:block!important;
          flex:0 0 auto!important;
          width:100%!important;
          height:auto!important;
          min-height:0!important;
          max-height:none!important;
          overflow:visible!important;
          overscroll-behavior:auto!important;
          -webkit-overflow-scrolling:auto!important;
          touch-action:auto!important;
        }

        html body cart-drawer.drawer .cart-drawer .cart-drawer__form,
        html body cart-drawer.drawer .cart-drawer .drawer__contents,
        html body cart-drawer.drawer .cart-drawer .drawer__cart-items-wrapper{
          display:block!important;
          flex:0 0 auto!important;
          width:100%!important;
          height:auto!important;
          min-height:0!important;
          max-height:none!important;
          overflow:visible!important;
        }

        html body cart-drawer.drawer .cart-drawer .drawer__footer{
          position:relative!important;
          inset:auto!important;
          display:block!important;
          flex:0 0 auto!important;
          width:100%!important;
          height:auto!important;
          min-height:0!important;
          max-height:none!important;
          overflow:visible!important;
          padding-bottom:max(2.4rem,env(safe-area-inset-bottom))!important;
        }

        html body cart-drawer.drawer .cart-drawer [data-gowin-drawer-suggestions]{
          overflow-x:auto!important;
          overflow-y:hidden!important;
          overscroll-behavior-x:contain!important;
          overscroll-behavior-y:auto!important;
          touch-action:pan-x pan-y!important;
        }

        html body cart-drawer.drawer .cart-drawer #CartDrawer-Checkout{
          margin-bottom:max(.4rem,env(safe-area-inset-bottom))!important;
        }
      `;
      (document.head||document.documentElement).appendChild(style);
    }

    document.querySelectorAll('cart-drawer .drawer__inner').forEach(inner=>{
      inner.setAttribute('data-gowin-unified-scroll','true');
    });
  };

  const loadCore=()=>{
    const existing=[...document.scripts].find(script=>script.src.includes('gowin-audit-improvements-core.js'));

    if(existing){
      if(existing.dataset.gowinLoaded==='true'){
        applyScrollFix();
      }else{
        existing.addEventListener('load',applyScrollFix,{once:true});
      }
      return;
    }

    if(!coreSrc||coreSrc===hostSrc){
      applyScrollFix();
      return;
    }

    const core=document.createElement('script');
    core.src=coreSrc;
    core.async=false;
    core.dataset.gowinAuditCore='true';
    core.addEventListener('load',()=>{
      core.dataset.gowinLoaded='true';
      applyScrollFix();
      requestAnimationFrame(applyScrollFix);
    },{once:true});
    core.addEventListener('error',applyScrollFix,{once:true});

    if(hostScript?.parentNode){
      hostScript.parentNode.insertBefore(core,hostScript.nextSibling);
    }else{
      (document.head||document.documentElement).appendChild(core);
    }
  };

  const resetOnOpen=new MutationObserver(records=>{
    records.forEach(record=>{
      const drawer=record.target;
      if(!(drawer instanceof Element)||!drawer.matches('cart-drawer'))return;

      const active=drawer.classList.contains('active');
      const wasActive=drawer.dataset.gowinWasActive==='true';

      if(active&&!wasActive){
        requestAnimationFrame(()=>{
          const inner=drawer.querySelector('.drawer__inner');
          if(inner)inner.scrollTop=0;
        });
      }

      drawer.dataset.gowinWasActive=String(active);
    });
  });

  const observeDrawers=()=>{
    document.querySelectorAll('cart-drawer').forEach(drawer=>{
      if(drawer.dataset.gowinScrollObserved==='true')return;
      drawer.dataset.gowinScrollObserved='true';
      drawer.dataset.gowinWasActive=String(drawer.classList.contains('active'));
      resetOnOpen.observe(drawer,{attributes:true,attributeFilter:['class']});
    });
  };

  loadCore();
  applyScrollFix();

  const init=()=>{
    applyScrollFix();
    observeDrawers();
  };

  document.readyState==='loading'
    ?document.addEventListener('DOMContentLoaded',init,{once:true})
    :init();

  document.addEventListener('cart:updated',()=>requestAnimationFrame(init));
  document.addEventListener('shopify:section:load',()=>requestAnimationFrame(init));
  window.addEventListener('pageshow',init);
})();

/* Drawer suggestion compare price + discount badge — keeps card dimensions unchanged. */
(()=>{
  if(window.GowinDrawerDiscountPricing)return;
  window.GowinDrawerDiscountPricing=true;

  const STYLE_ID='gowin-drawer-discount-pricing';
  const CARD_SELECTOR='.gowin-drawer-shipping__card';
  const SHIPPING_SELECTOR='cart-drawer [data-gowin-drawer-shipping]';
  const productCache=new Map();
  let frame=0;

  const ensureStyles=()=>{
    if(document.getElementById(STYLE_ID))return;

    const style=document.createElement('style');
    style.id=STYLE_ID;
    style.textContent=`
      html body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__price-row{
        grid-column:1!important;
        display:flex!important;
        align-items:baseline!important;
        gap:.35rem!important;
        width:100%!important;
        min-width:0!important;
        max-width:100%!important;
        height:auto!important;
        min-height:0!important;
        margin:0!important;
        overflow:hidden!important;
        white-space:nowrap!important;
        line-height:1.1!important;
      }

      html body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__price-row .gowin-drawer-shipping__price{
        flex:0 0 auto!important;
        display:inline!important;
        width:auto!important;
        min-width:0!important;
        max-width:none!important;
        margin:0!important;
        line-height:1.1!important;
        white-space:nowrap!important;
      }

      html body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__compare-price{
        flex:0 1 auto!important;
        min-width:0!important;
        max-width:8rem!important;
        margin:0!important;
        overflow:hidden!important;
        color:#8b93a3!important;
        font-size:.92rem!important;
        font-weight:600!important;
        line-height:1.1!important;
        text-overflow:ellipsis!important;
        white-space:nowrap!important;
        text-decoration-line:line-through!important;
        text-decoration-thickness:.1rem!important;
      }

      html body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__discount{
        flex:0 0 auto!important;
        display:inline-flex!important;
        align-items:center!important;
        justify-content:center!important;
        width:auto!important;
        min-width:0!important;
        min-height:1.65rem!important;
        margin:0!important;
        padding:.12rem .38rem!important;
        border-radius:999px!important;
        color:#3f7f1d!important;
        background:#edf6e8!important;
        font-size:.78rem!important;
        font-weight:850!important;
        line-height:1!important;
        letter-spacing:0!important;
        white-space:nowrap!important;
      }

      @media screen and (max-width:389px){
        html body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__price-row{
          gap:.25rem!important;
        }

        html body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__compare-price{
          max-width:6.7rem!important;
          font-size:.82rem!important;
        }

        html body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__discount{
          min-height:1.55rem!important;
          padding:.1rem .3rem!important;
          font-size:.72rem!important;
        }
      }
    `;

    (document.head||document.documentElement).appendChild(style);
  };

  const formatCRC=cents=>{
    const colones=Math.round(Number(cents||0)/100);
    return `₡ ${String(colones).replace(/\B(?=(\d{3})+(?!\d))/g,'.')}`;
  };

  const productJSONURL=link=>{
    try{
      const url=new URL(link.href,window.location.origin);
      url.search='';
      url.hash='';
      url.pathname=`${url.pathname.replace(/\.js$/,'').replace(/\/$/,'')}.js`;
      return url.toString();
    }catch(error){
      return '';
    }
  };

  const getProduct=url=>{
    if(!url)return Promise.resolve(null);

    if(!productCache.has(url)){
      productCache.set(
        url,
        fetch(url,{
          headers:{
            Accept:'application/json',
            'X-Requested-With':'XMLHttpRequest'
          },
          cache:'force-cache'
        })
          .then(response=>response.ok?response.json():null)
          .catch(()=>null)
      );
    }

    return productCache.get(url);
  };

  const clearPricing=(card)=>{
    const row=card.querySelector('.gowin-drawer-shipping__price-row');
    if(!row)return;

    const price=row.querySelector('.gowin-drawer-shipping__price');
    row.querySelectorAll('.gowin-drawer-shipping__compare-price,.gowin-drawer-shipping__discount').forEach(node=>node.remove());

    if(price&&row.parentNode){
      row.parentNode.insertBefore(price,row);
      row.remove();
    }
  };

  const renderDiscount=(card,variant)=>{
    const current=Number(variant?.price||0);
    const compare=Number(variant?.compare_at_price||0);

    if(current<=0||compare<=current){
      clearPricing(card);
      card.dataset.gowinDiscountState='none';
      return;
    }

    const price=card.querySelector('.gowin-drawer-shipping__price');
    if(!price){
      card.dataset.gowinDiscountState='none';
      return;
    }

    let row=card.querySelector('.gowin-drawer-shipping__price-row');

    if(!row){
      row=document.createElement('span');
      row.className='gowin-drawer-shipping__price-row';
      price.parentNode.insertBefore(row,price);
      row.appendChild(price);
    }

    row.querySelectorAll('.gowin-drawer-shipping__compare-price,.gowin-drawer-shipping__discount').forEach(node=>node.remove());

    const comparePrice=document.createElement('s');
    comparePrice.className='gowin-drawer-shipping__compare-price';
    comparePrice.textContent=formatCRC(compare);
    comparePrice.setAttribute('aria-label',`Precio anterior ${formatCRC(compare)}`);

    const percent=Math.max(1,Math.round(((compare-current)/compare)*100));
    const badge=document.createElement('span');
    badge.className='gowin-drawer-shipping__discount';
    badge.textContent=`−${percent}%`;
    badge.setAttribute('aria-label',`${percent}% de descuento`);

    row.append(comparePrice,badge);
    card.dataset.gowinDiscountState='done';
  };

  const enrichCard=async card=>{
    if(!card||card.dataset.gowinDiscountState)return;

    const button=card.querySelector('[data-gowin-drawer-add]');
    const link=card.querySelector('.gowin-drawer-shipping__product-title');
    const variantId=button?.dataset.gowinDrawerAdd;

    if(!variantId||!link){
      card.dataset.gowinDiscountState='none';
      return;
    }

    card.dataset.gowinDiscountState='loading';

    const product=await getProduct(productJSONURL(link));
    const variant=product?.variants?.find(item=>String(item.id)===String(variantId));

    if(!variant){
      card.dataset.gowinDiscountState='none';
      return;
    }

    renderDiscount(card,variant);
  };

  const init=(root=document)=>{
    ensureStyles();

    const cards=[];
    const addCard=card=>{
      if(!card||!card.closest(SHIPPING_SELECTOR)||cards.includes(card))return;
      cards.push(card);
    };

    if(root instanceof Element&&root.matches(CARD_SELECTOR))addCard(root);
    root.querySelectorAll?.(CARD_SELECTOR).forEach(addCard);
    cards.forEach(enrichCard);
  };

  const scheduleInit=()=>{
    cancelAnimationFrame(frame);
    frame=requestAnimationFrame(()=>init(document));
  };

  document.readyState==='loading'
    ?document.addEventListener('DOMContentLoaded',()=>init(document),{once:true})
    :init(document);

  document.addEventListener('cart:updated',scheduleInit);
  document.addEventListener('shopify:section:load',scheduleInit);
  window.addEventListener('pageshow',scheduleInit);

  const observer=new MutationObserver(records=>{
    for(const record of records){
      if([...record.addedNodes].some(node=>node.nodeType===1)){
        scheduleInit();
        break;
      }
    }
  });

  if(document.documentElement){
    observer.observe(document.documentElement,{childList:true,subtree:true});
  }
})();

/* END assets/gowin-audit-improvements.js */

/* BEGIN assets/gowin-audit-improvements-core.js */
/* GOWin audit improvements — 2026-08-05 */
(()=>{
  const selector='.mobile-facets__footer>.button.button--primary,.mobile-facets__close';

  const close=(trigger,event)=>{
    const drawer=trigger?.closest('menu-drawer.mobile-facets__wrapper');
    const details=drawer?.querySelector(':scope>details');
    const summary=details?.querySelector(':scope>summary');
    if(!drawer||!details||!summary)return;

    if(typeof drawer.closeMenuDrawer==='function'){
      drawer.closeMenuDrawer(event||new Event('click'),summary);
    }else{
      details.classList.remove('menu-opening');
      details.querySelectorAll('details[open]').forEach(item=>{
        item.removeAttribute('open');
        item.classList.remove('menu-opening');
      });
      summary.setAttribute('aria-expanded','false');
      document.body.classList.remove('overflow-hidden-mobile');
      details.removeAttribute('open');
      summary.focus({preventScroll:true});
    }

    setTimeout(()=>{
      details.classList.remove('menu-opening');
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded','false');
      document.body.classList.remove('overflow-hidden-mobile');
    },430);
  };

  window.gowinCloseMobileFacets=close;

  document.addEventListener('click',event=>{
    const trigger=event.target.closest?.(selector);
    if(!trigger)return;
    event.preventDefault();
    event.stopImmediatePropagation();
    close(trigger,event);
  });

  document.addEventListener('keydown',event=>{
    const trigger=event.target.closest?.('.mobile-facets__close');
    if(!trigger||!['Enter',' '].includes(event.key))return;
    event.preventDefault();
    close(trigger,event);
  });

  const a11y=(root=document)=>{
    root.querySelectorAll?.('.mobile-facets__close').forEach(control=>{
      control.setAttribute('role','button');
      control.setAttribute('aria-label','Cerrar filtros');
      if(!control.hasAttribute('tabindex'))control.tabIndex=0;
    });

    root.querySelectorAll?.('img.koin-icon-image:not([alt]),img.koin-icon-image[alt=""]').forEach(image=>{
      image.alt='Abrir asistencia de GOWin Store';
    });
  };

  const init=()=>a11y(document);
  document.readyState==='loading'
    ?document.addEventListener('DOMContentLoaded',init,{once:true})
    :init();

  const observer=new MutationObserver(records=>{
    for(const record of records){
      for(const node of record.addedNodes){
        if(node.nodeType===1)a11y(node);
      }
    }
  });

  if(document.documentElement){
    observer.observe(document.documentElement,{childList:true,subtree:true});
  }

  document.addEventListener('shopify:section:load',init);
  window.addEventListener('pageshow',init);
})();

/* Drawer shipping continuity — 2026-08-06 */
(()=>{
  let adding=false;

  const closeDrawer=(drawer)=>{
    if(typeof drawer.close==='function'){
      drawer.close();
      return;
    }

    drawer.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  };

  const resetDrawerScroll=(drawer)=>{
    const drawerItems=drawer.querySelector('cart-drawer-items');
    const contents=drawer.querySelector('#CartDrawer-CartItems');
    const suggestions=drawer.querySelector('[data-gowin-drawer-suggestions]');

    if(drawerItems){
      drawerItems.scrollLeft=0;
    }
    if(contents){
      contents.scrollLeft=0;
    }
    if(suggestions){
      suggestions.scrollLeft=0;
    }
  };

  const refreshDrawer=async(drawer)=>{
    const root=window.Shopify?.routes?.root||'/';
    const separator=root.includes('?')?'&':'?';
    const response=await fetch(`${root}${separator}sections=cart-drawer,cart-icon-bubble`,{
      headers:{
        Accept:'application/json',
        'X-Requested-With':'XMLHttpRequest'
      },
      cache:'no-store'
    });

    if(!response.ok)throw new Error('No se pudo actualizar el carrito');

    const sections=await response.json();
    const drawerMarkup=sections['cart-drawer'];

    if(!drawerMarkup)throw new Error('No se recibió el contenido del carrito');

    const parsed=new DOMParser().parseFromString(drawerMarkup,'text/html');
    const nextDrawer=parsed.querySelector('cart-drawer');
    const nextContents=parsed.querySelector('#CartDrawer');
    const currentContents=drawer.querySelector('#CartDrawer');

    if(!nextContents||!currentContents){
      throw new Error('El carrito no pudo renderizarse');
    }

    currentContents.innerHTML=nextContents.innerHTML;
    drawer.classList.toggle(
      'is-empty',
      nextDrawer?.classList.contains('is-empty')||false
    );
    drawer.classList.add('animate','active');
    document.body.classList.add('overflow-hidden');

    requestAnimationFrame(()=>resetDrawerScroll(drawer));

    const overlay=drawer.querySelector('#CartDrawer-Overlay');
    overlay?.addEventListener('click',()=>closeDrawer(drawer),{once:true});

    const iconMarkup=sections['cart-icon-bubble'];
    const currentIcon=document.querySelector('#cart-icon-bubble');

    if(iconMarkup&&currentIcon){
      const iconDoc=new DOMParser().parseFromString(iconMarkup,'text/html');
      const iconSection=iconDoc.querySelector(
        '#shopify-section-cart-icon-bubble,.shopify-section'
      );
      const nextIconHTML=
        iconSection?.innerHTML?.trim()||
        iconDoc.body?.innerHTML?.trim();

      if(nextIconHTML)currentIcon.innerHTML=nextIconHTML;
    }

    document.dispatchEvent(new CustomEvent('cart:updated',{
      detail:{source:'gowin-drawer-add'}
    }));
  };

  document.addEventListener('click',async event=>{
    const button=event.target.closest?.('[data-gowin-drawer-add]');
    if(!button||adding)return;

    event.preventDefault();

    const drawer=document.querySelector('cart-drawer');
    if(!drawer)return;

    adding=true;
    const label=button.querySelector('span');
    const original=label?.textContent||'Agregar';

    button.setAttribute('aria-busy','true');
    button.disabled=true;
    if(label)label.textContent='Agregando…';

    try{
      const payload=new FormData();
      payload.append('id',button.dataset.gowinDrawerAdd);
      payload.append('quantity','1');

      const response=await fetch(window.routes?.cart_add_url||'/cart/add.js',{
        method:'POST',
        headers:{
          Accept:'application/json',
          'X-Requested-With':'XMLHttpRequest'
        },
        body:payload
      });

      const state=await response.json();

      if(!response.ok||state.status){
        throw new Error(state.description||'No se pudo agregar el producto');
      }

      await refreshDrawer(drawer);
    }catch(error){
      if(label)label.textContent='Intenta otra vez';
      button.removeAttribute('aria-busy');
      button.disabled=false;

      setTimeout(()=>{
        if(button.isConnected&&label)label.textContent=original;
      },1800);
    }finally{
      adding=false;
    }
  });

  document.addEventListener('click',event=>{
    const drawer=event.target.closest?.('cart-drawer');
    if(!drawer)return;

    const control=event.target.closest?.(
      '.quantity__button, cart-remove-button, .drawer__close'
    );

    if(control){
      requestAnimationFrame(()=>resetDrawerScroll(drawer));
    }
  });
})();

/* Restaura scroll vertical, tarjetas originales y autoplay del drawer. */
(()=>{
  if(window.GowinDrawerSuggestionsRestored)return;
  window.GowinDrawerSuggestionsRestored=true;

  const STYLE_ID='gowin-drawer-suggestions-restored';
  const SELECTOR='cart-drawer.active [data-gowin-drawer-suggestions]';
  const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
  const AUTOPLAY_MS=3000;
  const USER_PAUSE_MS=5200;

  const ensureStyles=()=>{
    if(document.getElementById(STYLE_ID))return;

    const style=document.createElement('style');
    style.id=STYLE_ID;
    style.textContent=`
      body cart-drawer .drawer__inner {
        overflow: hidden !important;
      }

      body cart-drawer cart-drawer-items {
        display: block !important;
        flex: 1 1 auto !important;
        min-height: 0 !important;
        max-height: 100% !important;
        overflow-x: hidden !important;
        overflow-y: auto !important;
        overscroll-behavior-x: none !important;
        overscroll-behavior-y: contain !important;
        -webkit-overflow-scrolling: touch !important;
        touch-action: auto !important;
      }

      body cart-drawer .cart-drawer__form,
      body cart-drawer .drawer__contents,
      body cart-drawer .drawer__cart-items-wrapper {
        min-height: 0 !important;
        max-width: 100% !important;
      }

      body cart-drawer [data-gowin-drawer-shipping] {
        overflow-x: hidden !important;
        overflow-y: visible !important;
      }

      body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__recommendations {
        overflow: hidden !important;
      }

      body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__viewport {
        display: grid !important;
        grid-auto-flow: column !important;
        grid-template-rows: minmax(0, auto) !important;
        grid-auto-columns: min(28rem, 86%) !important;
        gap: .8rem !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        margin: 0 !important;
        padding: .15rem 0 .7rem !important;
        overflow-x: auto !important;
        overflow-y: hidden !important;
        scroll-snap-type: x mandatory !important;
        scroll-padding-inline: 0 !important;
        scrollbar-width: thin !important;
        scrollbar-color: rgba(104,167,42,.35) transparent !important;
        overscroll-behavior-x: contain !important;
        -webkit-overflow-scrolling: touch !important;
        touch-action: auto !important;
        contain: inline-size !important;
      }

      body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__card {
        display: grid !important;
        grid-template-columns: 7.2rem minmax(0,1fr) !important;
        grid-template-rows: minmax(0,1fr) !important;
        align-items: stretch !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        min-height: 10.2rem !important;
        gap: .9rem !important;
        padding: .8rem !important;
        overflow: hidden !important;
        scroll-snap-align: start !important;
        border: .1rem solid rgba(16,26,43,.09) !important;
        border-radius: 0 !important;
        background: #fff !important;
        box-shadow: 0 .6rem 1.8rem rgba(16,26,43,.055) !important;
      }

      body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__image-link {
        display: grid !important;
        place-items: center !important;
        align-self: center !important;
        width: 7.2rem !important;
        height: 7.2rem !important;
        overflow: visible !important;
        border-radius: 0 !important;
        background: transparent !important;
      }

      body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__image {
        display: block !important;
        width: 7.2rem !important;
        max-width: 100% !important;
        height: 7.2rem !important;
        object-fit: contain !important;
      }

      body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__card-copy {
        display: grid !important;
        grid-template-columns: minmax(0,1fr) auto !important;
        grid-template-rows: minmax(3.2rem,auto) auto !important;
        align-content: space-between !important;
        align-items: center !important;
        gap: .55rem .7rem !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
      }

      body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__product-title {
        grid-column: 1 / -1 !important;
        display: -webkit-box !important;
        min-height: 3.2rem !important;
        max-width: 100% !important;
        overflow: hidden !important;
        font-size: 1.16rem !important;
        line-height: 1.3 !important;
        -webkit-box-orient: vertical !important;
        -webkit-line-clamp: 2 !important;
      }

      body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__price {
        grid-column: 1 !important;
        display: block !important;
        font-size: 1.15rem !important;
        white-space: nowrap !important;
      }

      body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__add {
        grid-column: 2 !important;
        width: auto !important;
        min-width: 0 !important;
        min-height: 3.6rem !important;
        padding: .65rem 1rem !important;
        font-size: 1.05rem !important;
      }

      @media screen and (max-width: 749px) {
        body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__viewport {
          grid-auto-columns: min(26rem, 88%) !important;
        }

        body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__card {
          grid-template-columns: 6.4rem minmax(0,1fr) !important;
          min-height: 9.6rem !important;
        }

        body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__image-link,
        body cart-drawer [data-gowin-drawer-shipping] .gowin-drawer-shipping__image {
          width: 6.4rem !important;
          height: 6.4rem !important;
        }
      }
    `;

    (document.body||document.documentElement).appendChild(style);
  };

  const pause=(viewport,duration=USER_PAUSE_MS)=>{
    if(!viewport)return;
    viewport.dataset.gowinAutoplayPauseUntil=String(Date.now()+duration);
  };

  const bind=(viewport)=>{
    if(!viewport||viewport.dataset.gowinAutoplayBound==='true')return;
    viewport.dataset.gowinAutoplayBound='true';

    viewport.addEventListener('pointerdown',()=>pause(viewport),{passive:true});
    viewport.addEventListener('touchstart',()=>pause(viewport),{passive:true});
    viewport.addEventListener('wheel',()=>pause(viewport),{passive:true});
    viewport.addEventListener('focusin',()=>pause(viewport));
  };

  const activeViewport=()=>{
    const viewport=document.querySelector(SELECTOR);
    bind(viewport);
    return viewport;
  };

  const advance=()=>{
    if(reduceMotion.matches||document.hidden)return;

    const viewport=activeViewport();
    if(!viewport)return;
    if(viewport.matches(':hover')||viewport.contains(document.activeElement))return;
    if(Date.now()<Number(viewport.dataset.gowinAutoplayPauseUntil||0))return;

    const cards=[...viewport.querySelectorAll('.gowin-drawer-shipping__card')];
    if(cards.length<2)return;

    const current=cards.reduce((best,card)=>{
      const distance=Math.abs(card.offsetLeft-viewport.scrollLeft);
      return !best||distance<best.distance?{card,distance}:best;
    },null)?.card;

    const currentIndex=Math.max(0,cards.indexOf(current));
    const nextIndex=(currentIndex+1)%cards.length;
    const next=cards[nextIndex];
    const left=nextIndex===0?0:next.offsetLeft;

    viewport.scrollTo({left,behavior:'smooth'});
  };

  const init=()=>{
    ensureStyles();
    activeViewport();
  };

  document.readyState==='loading'
    ?document.addEventListener('DOMContentLoaded',init,{once:true})
    :init();

  document.addEventListener('cart:updated',()=>requestAnimationFrame(init));
  document.addEventListener('shopify:section:load',()=>requestAnimationFrame(init));
  window.addEventListener('pageshow',init);
  window.setInterval(advance,AUTOPLAY_MS);
})();

/* END assets/gowin-audit-improvements-core.js */
